var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"taktarea",style:(`
    width: calc((${_vm.project_length + 2} * (var(--workpackage_width) + 8px) + ${_vm.header_width}) * var(--taktplan_zoom));
    ${_vm.backlog?'background-color: var(--v-color-4-base);':''}
    ${_vm.height?`height: ${_vm.height}`:''}
    `)},[_vm._t("taktarea_header"),_vm._t("taktarea")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }